var _desc, _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Iconly/Curved/Light/2 User",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "#1F0A35",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M2.74 18.67C2.74 16.45 5.86 14.44 9.55 14.44C13.23 14.44 16.36 16.43 16.36 18.65C16.36 20.88 13.25 21.45 9.55 21.45C5.88 21.45 2.74 20.9 2.74 18.67Z",
    stroke: "#1F0A35",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M13.92 6.91C13.92 4.5 11.96 2.55 9.55 2.55C7.14 2.55 5.19 4.5 5.19 6.91C5.18 9.31 7.12 11.27 9.52 11.27L9.55 11.27C11.96 11.27 13.92 9.32 13.92 6.91Z",
    stroke: "#1F0A35",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M16.8 10.08C18.2 9.7 19.23 8.42 19.23 6.9C19.23 5.31 18.11 3.99 16.61 3.68",
    stroke: "#1F0A35",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M17.46 13.65C19.44 13.65 21.14 15 21.14 16.2C21.14 16.91 20.56 17.64 19.67 17.84",
    stroke: "#1F0A35",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsIcon);
export default __webpack_public_path__ + "static/media/leadsIcon.41edf88daa34e700bc6cca4f04b3c896.svg";
export { ForwardRef as ReactComponent };